import React, { forwardRef } from 'react';
import cn from 'classnames';

import styles from './checkbox.module.scss';

interface ICheckboxProps {
  id?: string;
  text?: string;
  isChecked?: boolean;
  isIndeterminate?: boolean;
  onChange?: () => void;
  className?: string;
  disabled?: boolean;
}

function Checkbox(
  props: ICheckboxProps,
  ref: any,
) {
  const {
    id,
    text,
    isChecked = false,
    onChange,
    className,
    isIndeterminate = false,
    disabled = false
  } = props;
  return (
    <label
      className={cn(styles['ag-checkbox-input'], className, {
        [styles.disabled]: disabled
      })}
      htmlFor={id}
    >
      <div className={styles['input-wrapper']}>
        <input
          ref={ref}
          className={cn({ indeterminate: isIndeterminate && isChecked })}
          id={id}
          type="checkbox"
          checked={isChecked}
          disabled={disabled}
          onChange={onChange}
        />
      </div>

      {text && (
        <span className={styles['input-text']}>
          {text}
        </span>
      )}
    </label>
  );
}

export default forwardRef(Checkbox);
